export const meta = { id: 'O31', slug: 'adicionar-participantes', title: 'Como adicionar Participantes', description: 'Associe pessoas à Formação para liberar a experiência correta para cada participante.', profile: 'owner', category: 'formacoes', type: 'task', status: 'published', order: 610, keywords: ['participantes','formação','associar participante','minhas formações'], previous: 'O30', next: 'O32', related: ['A06','O32'], updatedAt: '2026-08-17', appVersion: 'v1' }

# Como adicionar Participantes

Na versão atual, o Owner associa participantes manualmente à Formação.

<HelpImage pendingId="O29.1" alt="Lista de participantes de uma Formação" />

<Steps>
  <Step title="Abra a Formação">Acesse a área de Participantes.</Step>
  <Step title="Adicione participantes">Selecione os membros que devem participar do programa.</Step>
  <Step title="Confirme a inclusão">Salve a associação.</Step>
  <Step title="Verifique a experiência">O participante associado passa a encontrar a Formação em sua área permitida.</Step>
</Steps>

<Callout type="important">A associação faz parte da autorização. Um link direto não deve liberar uma Formação para quem não foi associado conforme as regras do produto.</Callout>
